import { render, staticRenderFns } from "./pipeline_labels.vue?vue&type=template&id=35e18ce6"
import script from "./pipeline_labels.vue?vue&type=script&lang=js"
export * from "./pipeline_labels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports